import React from 'react'

const Version = () => {
  return null
}

export default Version
